import { render, staticRenderFns } from "./deliveryDialog.vue?vue&type=template&id=7c6f40a7"
import script from "./deliveryDialog.vue?vue&type=script&lang=js"
export * from "./deliveryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports